import Trx from "@ledgerhq/hw-app-trx";
import Base from "./base/base";

export default class Tron extends Base {
    constructor(transport) {
        super(transport);
        this.bip44 = "44'/195'/0'/0/0";
    }

    // getAddress
    // data =>  {
    //   }
    // response => {
    //     address: "0x0000000000000000000000000000000000"
    //   }
    async getAddress(data) {
        const { address } = await new Trx(this.transport).getAddress(this.bip44);
        return { address };
    }

    // signTransaction
    // data =>  {
    //     encodeTx: "0x0000000000000000000000000000000000"
    //   }
    // response => {
    //     signature: "0x0000000000000000000000000000000000"
    //   }
    async signTransaction(data) {
        const rawTxHex = data.encodeTx;
        const signature = await new Trx(this.transport)
            .signTransaction(this.bip44, rawTxHex);
        return { signature };
    }
}